<div class="row mx-1 mt-3">
  <div class="col-7">
    <h4 class="pageTitle">{{ "Charts" | translate }}</h4>
  </div>
  <div class="col-5" style="text-align: end"></div>
  <hr />
</div>
<app-loader *ngIf="isLoading"></app-loader>
<app-filter
  [localFilters]="false"
  [fields]="filters"
  (applyClicked)="onFilterUpdate($event)"
></app-filter>
<div style="padding-left: 1%">
  <mat-card class="example-card" style="width: max-content">
    <mat-card-content>
      <p style="font-size: larger">Totale: {{ quantity }}</p>
    </mat-card-content>
  </mat-card>
</div>
<div
  class="chart-container"
  [ngStyle]="{
    border: '1px solid black',
    'pointer-events': isDisabled ? 'none' : 'auto',
    opacity: isDisabled ? '0.5' : '1'
  }"
>
  <div class="chart-box">
    <h3 class="chart-title">Observation Card</h3>
    <app-line-chart [data]="data"></app-line-chart>
  </div>

  <div class="chart-box">
    <h3 class="chart-title">Observation Status</h3>
    <app-pie-chart [data]="data" style="padding-top: 50px"></app-pie-chart>
  </div>
  <div class="chart-box">
    <h3 class="chart-title">Activity Type</h3>
    <app-polar-chart [data]="data" style="padding-top: 50px"></app-polar-chart>
  </div>
  <div class="chart-box">
    <h3 class="chart-title">Origin</h3>
    <app-origin-chart
      [data]="data"
      style="padding-top: 50px"
    ></app-origin-chart>
  </div>
</div>
<div
  [ngStyle]="{
    'pointer-events': isDisabled ? 'none' : 'auto',
    opacity: isDisabled ? '0.5' : '1',
    border: '1px solid black',
    'padding-bottom': '270px'
  }"
>
  <div class="chart-box">
    <h3 class="chart-title">Observation References</h3>
    <app-bar-chart [data]="data" style="padding-top: 50px"></app-bar-chart>
  </div>
</div>
